function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}

function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function RevealProductMetadata( element )
{ 

    var elementParent   = SearchParentsFor( element, "product-metafield-container" );
    var textContainer   = elementParent.querySelector( ".product-metafield-value-container" );
    var textHeight      = textContainer.querySelector( ".product-metafield-value-container_inner" ).offsetHeight;
    var elementArrow    = elementParent.querySelector( ".arrow_container img" );
     
    //get all containers and set the heights to 0
    var containers = document.querySelectorAll( ".product-metafield-container" );
    for( var i = 0; i < containers.length; i++ )
    {
        var container   = containers[ i ];
        var inner       = container.querySelector( ".product-metafield-value-container" );
        var arrow       = container.querySelector( ".arrow_container img" );
        inner.style.height  = 0 + "px";
        //rotate arrow
        arrow.style.transform = "rotate( 0deg )";       
    }
 
    //decide if the element clicked needs to be closed or not
    if( textContainer.offsetHeight > 0 )
    {
        textContainer.style.height  = 0 + "px";
        //rotate arrow
        elementArrow.style.transform = "rotate( 0deg )";
    }
    else
    {
        textContainer.style.height  = textHeight + "px";
        //rotate arrow
        elementArrow.style.transform = "rotate( 180deg )";
    }
}  

function ChangeProductImage( element )
{
    var parent                      = SearchParentsFor( element, "product-page--images-container" );
    var imageContainers             = parent.querySelectorAll( ".product-page--image" );
    var direction                   = element.dataset.direction;
    var trueImageIdx;
    var imageContainersNotVariants  =   []
    
    //get the index of the image that's currently visible
    for( var i = 0; i < imageContainers.length; i++ )
    {
        var imageContainer  = imageContainers[ i ];
        if( imageContainer.dataset.active == "true" )
        {
            trueImageIdx    = imageContainer.dataset.idx;
            imageContainer.dataset.active   = "false";
        }
        if( imageContainer.dataset.variantimage )
        {

        }
        else
        {
            imageContainersNotVariants.push( imageContainer );
        }
    }

    console.log( imageContainersNotVariants );

    for( i = 0; i < imageContainers.length; i++ )
    {
        var imageContainer     = imageContainers[ i ];
        var Idx                = Number( trueImageIdx );

        if( direction == "left" )
        {
            //if the image needed to be show is the first image
            if( Idx == 1 && ( i + 1 ) == 1 )
            {
                imageContainer.dataset.active = "false";
                imageContainers[ (imageContainers.length - 1) ].dataset.active = "true";
            }
            //show the image before the current image shown
            else if( ( i + 1 ) == ( Idx - 1 ) )
            {
                imageContainer.dataset.active = "true";
            }
        }
        else if( direction == "right" )
        {
            //if the image needed to be show is the last image
            if( Idx == imageContainers.length && ( i + 1 ) == imageContainers.length )
            {
                imageContainer.dataset.active = "false";
                imageContainers[ 0 ].dataset.active = "true";
            }
            //show the image after the current image shown
            else if( ( i + 1 ) == ( Idx + 1 ) )
            {
                imageContainer.dataset.active = "true";
            }            
        }
    }
}

function checkSubscribedProducts( cartProducts )
{
    var subscription = false;

    for( var i = 0; i < cartProducts.length; i++ )
    {
        var product = cartProducts[ i ];
        if( product.subscribed )
        {
            subscription = true;
        }
    }
    return subscription;
}

function checkSubscribeOption( )
{
    var subscribe           = false;
    var boldWidget          = document.querySelector( ".bold-ro__product" );
    var subscribeOptions    = boldWidget.querySelectorAll( 'input[name="bold-ro__selector_radio_button"]' );
    for( var i = 0; i < subscribeOptions.length; i++ )
    {
        var option = subscribeOptions[ i ];
        if( option.checked )
        {
            if( option.dataset.boldRecurring != undefined )
            {
                subscribe = true;
            }
        }
    }

    return subscribe;
}

function checkForOneOffBundle( g_cartItems )
{
    var bundle = false

    for( var i = 0; i < g_cartItems.length; i++ )
    {
        var item = g_cartItems[ i ];
        if( item.type == "Bundle Parent Product" )
        {
            bundle = true;
        }
    }

    return bundle;
}


function CheckBasket( element )
{
    var cartProducts = g_cartItems;
    console.log( g_cartItems );

    if( g_cartItems.length == 0 )
    {
        return true;
    }
    else
    {
        var bundle      = checkForOneOffBundle( g_cartItems );
        var subscribe   = checkSubscribeOption(  );

        if( bundle && subscribe )
        {
            event.preventDefault();
            if( bundle ) 
            {
                showMessage( bundle );
            }
             else
            { 
                showMessage( bundle ); 
            }
        }
        else
        {
            return true;
        }
    }
}

function showMessage( subscription )
{ 
    var overlay             = document.querySelector( ".product_overlay" );
    var messageContainer    = document.querySelector( ".product_overlay_container" );
    var hasSubscriptionMsg  = messageContainer.querySelector( ".has_subscription-text-container" );
    var noSubscriptionMsg   = messageContainer.querySelector( ".doesnt_subscription-text-container" );
    if( HasClass( overlay, "hidden" ) )
    {
        RemoveClass( messageContainer, "hidden" );
        RemoveClass( overlay, "hidden" );

        if( subscription )
        {
            RemoveClass( hasSubscriptionMsg, "hidden" );
        }
        else
        {
            RemoveClass( noSubscriptionMsg, "hidden" );
        }
    }
    else
    {  
        AddClass( messageContainer, "hidden" );
        AddClass( overlay, "hidden" );
        AddClass( hasSubscriptionMsg, "hidden" );
        AddClass( noSubscriptionMsg, "hidden" );
    }
}

function removeProductsFromBasket()
{
    var products        = g_cartItems;
    var cartProducts    = {};

    for( var i = 0; i < products.length; i++ )
    {
        var product     = products[ i ];
        var lineItem    = ( i + 1 );
        var variantId   = product.id;
        cartProducts[variantId] = 0;
    }
    console.log( cartProducts );    
    removeProductFromBasket( cartProducts );
}

function removeProductFromBasket( cartProducts )
{

    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                console.log( "updated cart" );
                showMessage();
                g_cartItems = [];
                var addToCartBtns = document.querySelectorAll( ".addtocart" );
                for( var i = 0; i < addToCartBtns.length; i++ )
                {
                    var btn = addToCartBtns[ i ];
                    btn.click();
                }
            }
            else
            {
                console.log( "removing old variant failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/update.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { updates: cartProducts } ) );
}

//gets called from product.liquid
function updateVariantDetails( variant )
{
    updateVariantPrice( variant );
}

function updateVariantPrice( variant )
{
    console.log( variant );
    var variantPrice    = ( variant.price / 100 );
    var priceContainer  = document.querySelector( ".price--container" );
    var currencySymbol  = priceContainer.dataset.currencySymbol;
    var price           =   currencySymbol + variantPrice;

    priceContainer.querySelector( "span" ).innerHTML = price;

    var variantTitle = variant.option1;
    NutritionalInfo( variantTitle );
}

function NutritionalInfo( variantTitle )
{
    var metafieldContainers = document.querySelectorAll( ".product-metafield-container" );
    
    for( var i = 0; i < metafieldContainers.length; i++ )
    {
        var metafieldContainer = metafieldContainers[ i ];
        if( metafieldContainer.dataset.key == "nutritional_info" )
        {
            var flavour                     = variantTitle;
            var metafieldContainerInner     = metafieldContainer.querySelector( ".product-metafield-value-container_inner" );
            
            var tableTitles                 = metafieldContainerInner.querySelectorAll( "strong" );
            var figures                     = metafieldContainerInner.querySelectorAll( "figure" );
            var paras                       = metafieldContainerInner.querySelectorAll( "p" );
            var tableIdx;

            for( var j = 0; j < tableTitles.length; j++ )
            {
                var tableTitle = tableTitles[ j ];
                var title;

                if( tableTitle.innerHTML.includes( "&amp;" ) )
                {
                    title = tableTitle.innerHTML.replace(/\&amp;/gi,'&');
                }
                else
                {
                    title = tableTitle.innerHTML;
                }

                if( title.includes( flavour ) )
                {
                    tableIdx    =   j;
                }
            }

            for( var j = 0; j < figures.length; j++ )
            {
                var figure = figures[ j ];
                if( j == tableIdx )
                {
                    RemoveClass( figure, "hidden" );
                }
                else
                {
                    AddClass( figure, "hidden" );
                }
            }

            for( var j = 0; j < paras.length; j++ )
            {
                var para = paras[ j ];
                var title;

                if( para.innerHTML.includes( "&amp;" ) )
                {
                    title = para.innerHTML.replace(/\&amp;/gi,'&');
                }
                else
                {
                    title = para.innerHTML;
                }

                if( title.includes( flavour ) )
                {
                    RemoveClass( para, "hidden" );
                }
                else
                {
                    AddClass( para, "hidden" )
                }
            }
        }
    }

    showCorrectIngrediants( variantTitle );
}

function showCorrectIngrediants( variantTitle )
{
    var metafieldContainers = document.querySelectorAll( ".product-metafield-container" );

    for( var i = 0; i < metafieldContainers.length; i++ )
    {
        var metafieldContainer = metafieldContainers[ i ];
        if( metafieldContainer.dataset.key == "nutritional_info" )
        {
            var flavour                     = variantTitle;
        }
    }

}

function initialiseProductPage()
{
    var addToCartBtns = document.querySelectorAll( ".addtocart" );
    for( var i = 0; i < addToCartBtns.length; i++ )
    {
        var btn = addToCartBtns[ i ];
        btn.addEventListener( "click", CheckBasket );
    }
}

initialiseProductPage();
